import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@components/Text/Text.component';
import { urlEnum } from '@utils/url';

export interface MeteoDescriptionProps {
  isMobile: boolean;
}
export const MeteoDescription: FC<MeteoDescriptionProps> = ({ isMobile }) => {
  const className = isMobile
    ? 'forecasts-title wrapper-s row-up-m space-between plc-my-m plc-mb-up-m-l plc-mt-up-m-xxl'
    : 'forecasts-title wrapper-s flex space-between plc-my-m';
  return (
    <div className={className}>
      <Text className="plc-mb-s" tag="h2" variant="p">
        <Trans i18nKey="meteo.desc">
          Les prévisions sont gratuites pour les 5 premiers jours et réservées aux abonnés Pleinchamp Pro pour les 10
          suivants. <a href={urlEnum.meteoAgricoleSurMesure}>En savoir plus</a>
        </Trans>
      </Text>
    </div>
  );
};
